import React, { useState, useEffect, useCallback } from "react";
import { obtenerListaArticulos } from "../../../store/Articulos/thunkArticulos";
import { useDispatch } from "react-redux";
import Select from "react-select";
import { CrearArticulo } from "./CrearArticulo";
import { EditarArticulo } from "./EditarArticulo";
import "../../css/ColorTable.css"; // Importa el archivo CSS

export const ListaArticulos = () => {
    const dispatch = useDispatch();
    const [articulos, setArticulos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [pageSize, setPageSize] = useState(20);
    const [currentPage, setCurrentPage] = useState(1);
    const [nombreFiltro, setNombreFiltro] = useState("");
    const [hotelFiltros, setHotelFiltros] = useState([]);
    const [hoteles, setHoteles] = useState([]);

    // Estados independientes para cada modal
    const [openCreateModal, setOpenCreateModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [selectedArticulo, setSelectedArticulo] = useState(null);

    // Funciones para manejar los modales
    const handleOpenCreateModal = () => setOpenCreateModal(true);
    const handleCloseCreateModal = () => setOpenCreateModal(false);

    const handleOpenEditModal = (articulo) => {
        setSelectedArticulo(articulo);
        setOpenEditModal(true);
    };
    const handleCloseEditModal = () => {
        setSelectedArticulo(null);
        setOpenEditModal(false);
    };

    // Función para obtener los artículos
    const fetchArticulos = useCallback(
        async (estado) => {
            try {
                setLoading(true);
                setError(null);
                const response = await dispatch(obtenerListaArticulos(estado));
                setArticulos(response || []);

                // Extraer hoteles únicos para el filtro
                const hotelesUnicos = Array.from(new Set(response.map((articulo) => articulo.nombre_hotel))).map((hotel) => ({
                    value: hotel,
                    label: hotel,
                }));
                setHoteles(hotelesUnicos);
            } catch (err) {
                console.error("Error al obtener los artículos:", err);
                setError("No se pudo cargar la lista de artículos.");
            } finally {
                setLoading(false);
            }
        },
        [dispatch],
    );

    // Efecto para cargar los artículos al montar el componente
    useEffect(() => {
        fetchArticulos(1);
    }, [fetchArticulos]);

    // Manejar el cambio de tamaño de página
    const handlePageSizeChange = (e) => {
        setPageSize(Number(e.target.value));
        setCurrentPage(1);
    };

    // Manejar el cambio de filtro por nombre
    const handleNombreFiltroChange = (e) => {
        setNombreFiltro(e.target.value);
        setCurrentPage(1);
    };

    // Manejar el cambio de filtro por hotel
    const handleHotelFiltrosChange = (selectedOptions) => {
        setHotelFiltros(selectedOptions || []);
        setCurrentPage(1);
    };

    // Filtrar los artículos
    const filteredArticulos = articulos.filter((articulo) => {
        const nombreMatch = articulo.nombre_articulo.toLowerCase().includes(nombreFiltro.toLowerCase());
        const hotelMatch = hotelFiltros.length === 0 || hotelFiltros.some((hotel) => hotel.value === articulo.nombre_hotel);
        return nombreMatch && hotelMatch;
    });

    // Paginación
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const paginatedArticulos = filteredArticulos.slice(startIndex, endIndex);
    const totalPages = Math.ceil(filteredArticulos.length / pageSize);

    // Renderizado condicional para estado de carga o error
    if (loading) return <div>Cargando artículos...</div>;
    if (error) return <div className="text-danger">{error}</div>;

    // Renderiza la tabla de artículos
    return (
        <div className="table-responsive">
            <div className="row">
                <div className="col-md-4 mb-2">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Filtrar por nombre"
                        value={nombreFiltro}
                        onChange={handleNombreFiltroChange}
                    />
                </div>
                <div className="col-md-4 mb-2">
                    <Select isMulti options={hoteles} value={hotelFiltros} onChange={handleHotelFiltrosChange} placeholder="Seleccionar Hoteles" />
                </div>
            </div>

            {/* Controles de filtro */}
            <div className="d-flex justify-content-between align-items-center mb-3">
                <button className="btn btn-dark" onClick={handleOpenCreateModal}>
                    Crear Artículo
                </button>

                <div>
                    <label htmlFor="pageSizeSelect">Mostrar:</label>
                    <select id="pageSizeSelect" className="form-select w-auto d-inline-block mx-2" value={pageSize} onChange={handlePageSizeChange}>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </select>
                    artículos por página
                </div>
            </div>

            <table
                className="table table-striped table dt-responsive w-100 display text-left hoverable-table"
                style={{ fontSize: "15px", width: "100%", textAlign: "left" }}
            >
                <thead>
                    <tr>
                        <th className="text-center">Nombre artículo</th>
                        <th className="text-center">Hotel</th>
                        <th className="text-left">Descripción</th>
                        <th className="text-center">Precio General</th>
                        <th className="text-center">13%</th>
                        <th className="text-center">10%</th>
                        <th className="text-center">Grupo</th>
                        <th className="text-center">Estado</th>
                    </tr>
                </thead>
                <tbody>
                    {paginatedArticulos.length > 0 ? (
                        paginatedArticulos.map((articulo, key) => (
                            <tr key={key} onClick={() => handleOpenEditModal(articulo)} style={{ cursor: "pointer" }}>
                                <td className="text-center">{articulo.nombre_articulo}</td>
                                <td className="text-center">{articulo.nombre_hotel}</td>
                                <td className="text-left">{articulo.desc_articulo}</td>
                                <td className="text-center">{articulo.precio_art}</td>
                                <td className="text-center">{articulo.trece_articulo === 1 ? "13%" : "No"}</td>
                                <td className="text-center">{articulo.diez_articulo === 1 ? "10%" : "No"}</td>
                                <td className="text-center">{articulo.grupo_articulo}</td>
                                <td className="text-center">{articulo.estado_articulo === 1 ? "Activo" : "Inactivo"}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="8" className="text-center">
                                No hay artículos disponibles.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            {/* Paginación */}
            <div className="d-flex justify-content-center align-items-center mt-3">
                <button className="btn btn-primary mx-2" disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)}>
                    Anterior
                </button>
                <span>
                    Página {currentPage} de {totalPages}
                </span>
                <button className="btn btn-primary mx-2" disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)}>
                    Siguiente
                </button>
            </div>

            {/* Modales */}
            <CrearArticulo open={openCreateModal} handleClose={handleCloseCreateModal} fetchArticulos={fetchArticulos} type="lista" />
            {selectedArticulo && (
                <EditarArticulo
                    open={openEditModal}
                    handleClose={handleCloseEditModal}
                    fetchArticulos={fetchArticulos}
                    type="lista"
                    Articulo={selectedArticulo}
                />
            )}
        </div>
    );
};
